import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

// Attach stored token as Authorization header for every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear stored token and redirect to login — EXCEPT when we're on
// a public route (staff members opening a tokenized Radio link have no
// account and must not be bounced to a login page).
// 13-May-2026: added /forgot-password and /reset-password — these are
// reached by un-authenticated users (the whole point), so a 401 on
// /me must NOT bounce them to /login or the pages become unreachable.
const PUBLIC_PATH_PREFIXES = ['/r/', '/soul/', '/dreamweaver', '/c/', '/login', '/forgot-password', '/reset-password'];
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      const onPublicRoute = PUBLIC_PATH_PREFIXES.some((p) => path === p || path.startsWith(p));
      if (!onPublicRoute) {
        localStorage.removeItem('access_token');
        if (path !== '/login') window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
export { BACKEND_URL };
